import {Component, ElementRef, HostListener, Input, ViewChild} from '@angular/core';
import {Photographer} from '../../../entities/photographer/photographer.entity';
import { TitleCasePipe } from '@angular/common';
import {TranslocoPipe} from '@jsverse/transloco';
import {AppImageComponent} from '../../../../core/components/image/image';
@Component({
  selector: 'app-photographer-list-item',
  imports: [
    TranslocoPipe,
    TitleCasePipe,
    AppImageComponent,
  ],
  templateUrl: './photographer-list-item.component.html',
  styleUrl: './photographer-list-item.component.scss'
})
export class PhotographerListItemComponent {
  @Input() photographer: Photographer|null = null;
  @ViewChild('certificationModal') certificationModalRef?: ElementRef<HTMLElement>;
  @ViewChild('certificationContainer') certificationContainerRef?: ElementRef<HTMLElement>;

  public certificationModalVisible = false;
  public certificationModalOffset = 0;

  public showCertificationModal(): void {
    this.certificationModalVisible = true;
    // Wait for the modal to render before measuring.
    requestAnimationFrame(() => this.updateCertificationModalPosition());
  }

  public hideCertificationModal(): void {
    this.certificationModalVisible = false;
  }

  @HostListener('window:resize')
  onResize(): void {
    if (this.certificationModalVisible) {
      this.updateCertificationModalPosition();
    }
  }

  private updateCertificationModalPosition(): void {
    const modalEl = this.certificationModalRef?.nativeElement;
    const containerEl = this.certificationContainerRef?.nativeElement;
    if (!modalEl || !containerEl) {
      return;
    }

    const minMargin = 8;
    const viewportWidth = window.innerWidth;
    const modalRect = modalEl.getBoundingClientRect();
    const containerRect = containerEl.getBoundingClientRect();

    const defaultLeft = containerRect.left + containerRect.width / 2 - modalRect.width / 2;
    const clampedLeft = Math.max(minMargin, Math.min(defaultLeft, viewportWidth - modalRect.width - minMargin));

    this.certificationModalOffset = clampedLeft - defaultLeft;
  }
}
